// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Spaces from "../theme/Spaces.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "display-k1xSpc": "display-xt0psk2",
    $$css: "wino-gc:src/resources/layout-and-structure/InlineText.res.js:9"
  },
  textAlignLeft: {
    "textAlign-k9WMMc": "textAlign-xdpxx8g",
    $$css: "wino-gc:src/resources/layout-and-structure/InlineText.res.js:12"
  },
  textAlignJustify: {
    "textAlign-k9WMMc": "textAlign-xmw9mke",
    $$css: "wino-gc:src/resources/layout-and-structure/InlineText.res.js:15"
  },
  textAlignCenter: {
    "textAlign-k9WMMc": "textAlign-x2b8uid",
    $$css: "wino-gc:src/resources/layout-and-structure/InlineText.res.js:18"
  },
  textAlignRight: {
    "textAlign-k9WMMc": "textAlign-x1hr2gdg",
    $$css: "wino-gc:src/resources/layout-and-structure/InlineText.res.js:21"
  }
};
function textStyleFromParams(linespace, align, wrap, maxLines) {
  return Stylex.props(styles.root, {
    lineHeight: wrap ? "auto" : `calc(100% + ` + String(Spaces.toFloat(linespace)) + `px)`,
    whiteSpace: wrap ? "normal" : "nowrap"
  }, maxLines !== undefined ? {
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: String(Primitive_option.valFromOption(maxLines)),
    display: "-webkit-box",
    overflow: "hidden"
  } : {}, align === "right" ? styles.textAlignRight : align === "justify" ? styles.textAlignJustify : align === "center" ? styles.textAlignCenter : styles.textAlignLeft);
}
function InlineText(props) {
  let __linespace = props.linespace;
  let __wrap = props.wrap;
  let __align = props.align;
  let align = __align !== undefined ? __align : "left";
  let wrap = __wrap !== undefined ? __wrap : true;
  let linespace = __linespace !== undefined ? __linespace : "xsmall";
  let newrecord = {
    ...textStyleFromParams(linespace, align, wrap, props.maxLines)
  };
  return JsxRuntime.jsx("span", (newrecord.children = props.children, newrecord));
}
let make = InlineText;
export { make };
/* styles Not a pure module */